export default "/_next/static/media/landing-hero-mob.8dfc2462068809fc9c8ba3b0dc06ee24.mp4";